



























































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { formRules } from '@/common/util/validator';
import ButtonPanel from '@/components/ButtonPanel.vue';
import { Notification } from '@/http';
import { enums } from '@/common/enums';
import DescribePanel from '@/components/DescribePanel.vue';
@Component({
    components: { BaseContainer, ButtonPanel, PageDescribe, DescribePanel },
})
export default class NotificationsDetail extends Vue {
    public $refs: {
        form: HTMLFormElement;
        PWEdit: HTMLFormElement;
        DescribePanel: HTMLFormElement;
    };
    public content: any;
    public form = {};
    public loading: boolean = false;
    public id: any = '';

    mounted() {
        this.id = this.$route.query.id;
        this.loadData();
    }
    public async loadData() {
        this.loading = true;
        await Notification.GetNotificationDetail(this.id)
            .then((res) => {
                if (res) {
                    this.form = res;
                    this.loading = false;
                } else {
                    this.loading = false;
                }
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    back() {
        this.$router.push('/notifications');
    }
}
